// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * @shapeshiftoss/bitcoincash-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 10.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { VinScriptSig } from './VinScriptSig';
import {
    VinScriptSigFromJSON,
    VinScriptSigFromJSONTyped,
    VinScriptSigToJSON,
} from './VinScriptSig';

/**
 * Contains info about a transaction output
 * @export
 * @interface Vout
 */
export interface Vout {
    /**
     * 
     * @type {string}
     * @memberof Vout
     */
    value: string;
    /**
     * 
     * @type {number}
     * @memberof Vout
     */
    n: number;
    /**
     * 
     * @type {string}
     * @memberof Vout
     */
    opReturn?: string;
    /**
     * 
     * @type {VinScriptSig}
     * @memberof Vout
     */
    scriptPubKey: VinScriptSig;
    /**
     * 
     * @type {Array<string>}
     * @memberof Vout
     */
    addresses?: Array<string>;
}

/**
 * Check if a given object implements the Vout interface.
 */
export function instanceOfVout(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "value" in value;
    isInstance = isInstance && "n" in value;
    isInstance = isInstance && "scriptPubKey" in value;

    return isInstance;
}

export function VoutFromJSON(json: any): Vout {
    return VoutFromJSONTyped(json, false);
}

export function VoutFromJSONTyped(json: any, ignoreDiscriminator: boolean): Vout {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'value': json['value'],
        'n': json['n'],
        'opReturn': !exists(json, 'opReturn') ? undefined : json['opReturn'],
        'scriptPubKey': VinScriptSigFromJSON(json['scriptPubKey']),
        'addresses': !exists(json, 'addresses') ? undefined : json['addresses'],
    };
}

export function VoutToJSON(value?: Vout | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'value': value.value,
        'n': value.n,
        'opReturn': value.opReturn,
        'scriptPubKey': VinScriptSigToJSON(value.scriptPubKey),
        'addresses': value.addresses,
    };
}

